import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "max-w-7xl mx-auto p-4" }
const _hoisted_2 = { class: "grid grid-cols-1 gap-3" }
const _hoisted_3 = { class: "grid grid-cols-1 gap-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "sr-only" }, "ADA accommodations", -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "grid grid-cols-1 md:grid-cols-4 gap-3" }
const _hoisted_7 = { class: "order-last md:order-first" }
const _hoisted_8 = { class: "md:col-span-3" }
const _hoisted_9 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Anchor = _resolveComponent("Anchor")!
  const _component_Copyright = _resolveComponent("Copyright")!
  const _component_Box = _resolveComponent("Box")!

  return (_openBlock(), _createBlock(_component_Box, {
    as: "footer",
    color: _ctx.color,
    variant: _ctx.variant
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("section", null, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("p", null, [
                _createTextVNode(" The City of Portland ensures meaningful access to city programs, services, and activities to comply with Civil Rights Title VI and ADA Title II laws and reasonably provides: translation, interpretation, modifications, accommodations, alternative formats, auxiliary aids and services. To request these services, contact the Portland Bureau of Transportation at 311 ("),
                _createVNode(_component_Anchor, { url: "tel:503-823-400" }, {
                  default: _withCtx(() => [
                    _createTextVNode("503-823-4000")
                  ]),
                  _: 1
                }),
                _createTextVNode("), for Relay Service & TTY: "),
                _createVNode(_component_Anchor, { url: "tel:711" }, {
                  default: _withCtx(() => [
                    _createTextVNode("711")
                  ]),
                  _: 1
                }),
                _createTextVNode(". ")
              ]),
              _createElementVNode("p", null, [
                _createTextVNode(" Traducción e Interpretación | Biên Dịch và Thông Dịch | अनुवादन तथा व्याख्या 口笔译服务 | Устный и письменный перевод | Turjumaad iyo Fasiraad Письмовий і усний переклад | Traducere și interpretariat | Chiaku me Awewen Kapas | Translation and Interpretation "),
                _createVNode(_component_Anchor, { url: "tel:503-823-4000" }, {
                  default: _withCtx(() => [
                    _createTextVNode("503-823-4000")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          (_ctx.hasTop)
            ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
                _renderSlot(_ctx.$slots, "top")
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("section", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_Copyright)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _renderSlot(_ctx.$slots, "middle")
            ])
          ]),
          (_ctx.hasBottom)
            ? (_openBlock(), _createElementBlock("section", _hoisted_9, [
                _renderSlot(_ctx.$slots, "bottom")
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 3
  }, 8, ["color", "variant"]))
}